<div class="no-po-items-modal">
	<h2>Add NO PO Items to Invoice</h2>

	<div class="dialog-content">
		<!-- GRNs Section -->
		<div class="groups-section mb-3">
			<div class="d-flex justify-content-between align-items-center mb-2">
				<label class="form-label mb-0">GRNs</label>
				<button class="btn btn-sm btn-primary" (click)="addGroup()" type="button">
					<i class="fa fa-plus"></i> Add GRN
				</button>
			</div>
			<div class="groups-list" *ngIf="groups.length > 0">
				<div class="grn-card"
					 *ngFor="let group of groups; let i = index"
					 [class.grn-card-active]="isActiveGroup(group.id)"
					 [style.cursor]="'pointer'"
					 (click)="setActiveGroup(group.id)">
					<div class="grn-card-header">
						<div class="grn-card-number">
							<div class="grn-select-indicator" [class.active]="isActiveGroup(group.id)">
								<i class="fa" [class.fa-check-circle]="isActiveGroup(group.id)" [class.fa-circle]="!isActiveGroup(group.id)"></i>
							</div>
							<span class="grn-label">GRN {{ i + 1 }}</span>
							<span class="grn-item-count" *ngIf="getGroupItemCount(group.id) > 0">
								({{ getGroupItemCount(group.id) }} items)
							</span>
						</div>
						<button class="grn-delete-btn"
								(click)="removeGroup(i); $event.stopPropagation()"
								type="button"
								[disabled]="getGroupItemCount(group.id) > 0"
								matTooltip="Delete GRN">
							<i class="fa fa-times"></i>
						</button>
					</div>
					<div class="grn-card-body">
						<label class="grn-input-label">New PO Number <span class="required-asterisk">*</span></label>
						<input type="text"
							   class="grn-po-input"
							   [(ngModel)]="group.poNumber"
							   required
							   placeholder="Enter PO number"
							   [class.invalid]="!group.poNumber || group.poNumber.trim() === ''"
							   (click)="$event.stopPropagation()"
							   (focus)="setActiveGroup(group.id)">
					</div>
				</div>
			</div>
			<div class="text-muted" *ngIf="groups.length === 0">
				<small>No GRNs created. Click "Add GRN" to create a GRN and assign items to it.</small>
			</div>
		</div>

		<!-- Filter Toolbar -->
		<div class="filter-toolbar mb-3">
			<div class="row">
				<div class="col-md-12 mb-2">
					<label class="form-label">Search Items</label>
					<div class="input-group">
						<input type="text" class="form-control" [(ngModel)]="searchTerm" (input)="applyFilters()" placeholder="Search by item code, description, location, vendor, or reference">
						<span class="input-group-text"><i class="fa fa-search"></i></span>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Date From</mat-label>
						<input matInput [matDatepicker]="dateFromPicker" [(ngModel)]="dateFrom" (dateChange)="onDateFilterChange()">
						<mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
						<mat-datepicker #dateFromPicker></mat-datepicker>
					</mat-form-field>
				</div>
				<div class="col-md-3">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Date To</mat-label>
						<input matInput [matDatepicker]="dateToPicker" [(ngModel)]="dateTo" (dateChange)="onDateFilterChange()">
						<mat-datepicker-toggle matSuffix [for]="dateToPicker"></mat-datepicker-toggle>
						<mat-datepicker #dateToPicker></mat-datepicker>
					</mat-form-field>
				</div>
				<div class="col-md-2">
					<label class="form-label">Location</label>
					<select class="form-control" [(ngModel)]="selectedLocation" (change)="applyFilters()">
						<option value="">All Locations</option>
						<option *ngFor="let loc of availableLocations" [value]="loc">{{ loc }}</option>
					</select>
				</div>
				<div class="col-md-2">
					<label class="form-label">Min Price</label>
					<div class="input-group">
						<span class="input-group-text">$</span>
						<input type="number" class="form-control" [(ngModel)]="priceMin" (input)="applyFilters()" (blur)="normalizePriceFilter('min')" step="0.01" min="0" placeholder="0.00">
					</div>
				</div>
				<div class="col-md-2">
					<label class="form-label">Max Price</label>
					<div class="input-group">
						<span class="input-group-text">$</span>
						<input type="number" class="form-control" [(ngModel)]="priceMax" (input)="applyFilters()" (blur)="normalizePriceFilter('max')" step="0.01" min="0" placeholder="0.00">
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12 d-flex justify-content-between align-items-center">
					<div>
						<button class="btn btn-sm btn-secondary" (click)="clearFilters()">
							<i class="fa fa-times"></i> Clear Filters
						</button>
					</div>
					<div class="results-count">
						<span *ngIf="!loading">Showing {{ resultsCount }} of {{ stockmovements.length }} items</span>
						<span *ngIf="selectedCount > 0" class="selected-count">({{ selectedCount }} selected)</span>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="loading" class="text-center p-4">
			<div class="spinner-border text-primary" role="status">
				<span class="sr-only">Loading...</span>
			</div>
			<p class="mt-2">Loading stockmovements...</p>
		</div>

		<div *ngIf="!loading && filteredStockmovements.length === 0" class="text-center p-4">
			<p>No stockmovements without PO found for this supplier.</p>
			<p *ngIf="searchTerm || dateFrom || dateTo || selectedLocation || priceMin || priceMax" class="text-muted">
				Try adjusting your filters.
			</p>
		</div>

		<div *ngIf="!loading && filteredStockmovements.length > 0" class="table-container">
			<table class="table table-sm table-fixed">
				<thead>
					<tr>
						<th>
							<input type="checkbox" (change)="toggleAll()" [checked]="selectedItems.size === filteredStockmovements.length && filteredStockmovements.length > 0">
						</th>
						<th>Item Code</th>
						<th>Description</th>
						<th class="text-right">Qty</th>
						<th class="text-right">Price</th>
						<th>Date Received</th>
						<th>Location</th>
						<th>Vendor</th>
						<th>Reference</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let sm of filteredStockmovements"
						[ngClass]="{'selected': isSelected(sm.stkmoveno), 'assigned-to-grn': getItemGroup(sm.stkmoveno)}">
						<td>
							<input type="checkbox" (change)="toggleSelection(sm.stkmoveno)" [checked]="isSelected(sm.stkmoveno)">
						</td>
						<td>{{ sm.stockid }}</td>
						<td>{{ sm.description }}</td>
						<td class="text-right">{{ sm.qty | number:'1.2-2' }}</td>
						<td class="text-right">
							<div class="input-group input-group-sm price-input">
								<span class="input-group-text">$</span>
								<input type="number" class="form-control" [(ngModel)]="sm.editablePrice" (blur)="updatePrice(sm, $event)" step="0.01" min="0">
							</div>
						</td>
						<td>{{ sm.trandate | date:'shortDate' }}</td>
						<td>{{ sm.loccode }} <span *ngIf="sm.locationname">({{ sm.locationname }})</span></td>
						<td>{{ sm.debtorno }}</td>
						<td>{{ sm.reference }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div class="dialog-actions">
		<button class="btn btn-secondary" (click)="cancel()" [disabled]="processing">Cancel</button>
		<button class="btn btn-primary" (click)="addSelectedToInvoice()" [disabled]="processing || selectedItems.size === 0">
			<span *ngIf="processing">
				<span class="spinner-border spinner-border-sm mr-2" role="status"></span>
				Processing...
			</span>
			<span *ngIf="!processing">Add Selected to Invoice ({{ selectedItems.size }})</span>
		</button>
	</div>
</div>
